import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"บริการ Payroll Outsourcing — เงินเดือน ประกันสังคม ภาษี ณ ที่จ่าย","metaTitle":"Payroll Outsourcing — บริการทำเงินเดือนครบวงจร | NYC","metaDesc":"จัดทำเงินเดือน ยื่น ภ.ง.ด.1, ประกันสังคม สปส.1-10, กองทุนสำรองเลี้ยงชีพ พร้อม Payslip อีเมล /พนักงาน/เดือน — คุยกับผู้เชี่ยวชาญตัวจริง ตอบกลับภายในไม่กี่นาที"},"en":{"h1":"Payroll Outsourcing — Salary, SSO, PIT, Provident Fund","metaTitle":"Payroll Outsourcing Thailand — Full Compliance | NYC","metaDesc":"Full payroll: salary calc, PND.1, SSO Sor.Por.Sor.1-10, workers' compensation, PVD, encrypted e-paysli — Free consultation — message us for a same-day answer."}} as const;

export const Route = createFileRoute("/en/accounting/payroll")({
  head: () => {
    const url = `${SEO_SITE}/en/accounting/payroll`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/accounting/payroll", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/accounting/payroll", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/accounting/payroll", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/accounting/payroll", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/accounting/payroll", "/en/accounting/payroll")],
    };
  },
  component: () => <SubServicePage slug="accounting/payroll" locale="en" />,
});
